export default "__VITE_ASSET__7f40a222__"